export const dummyCardCurrent = {
  error: false,
  data: {
    list: [
      {
        authorId: 5557808,
        authorName: "JadeWolveS",
        blogId: 5572828,
        blogTitle: "청랑",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/5572828/attach/ce371994a5c5423c8cddef0d0511ed05",
        blogUrl: "https://jadewolves.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/cmsBek/btsCxGQZQ2A/oyJIWJBfQH5rvW7yAbgaO0/img.png",
        entryId: 1226,
        entryTitle: "발전을 위한 마음가짐",
        entryUrl: "https://jadewolves.tistory.com/entry/%E3%84%B13-3",
        entrySummary:
          "요리연구가 백종원이 유튜브로 진행했던 예산시장 프로젝트에서도 상인들에게 배신감을 느껴 서운함을 드러냈습니다. 예전에 TV 프로그램으로 진행했던 '골목식당'에 이어서 연이은 상인들의 배신감으로 지켜보는 대중들의 안타까움이 높아만 가고 있습니다. 예산시장 상인 중 누군가 국민신문고에 백종원의 회사에서 소스와 공급 제품을 강제로 비싸게 팔고 있다고 글을 올렸습니다. 백종원은 예산시장 상인들과의 간담회 자리에서 보내는 소스는 가맹점과 같은 가격에 공급하고 있다고  밝혔고 상인들에게 섭섭함과 배신감을 느낀다고 넋두리했습니다.'골목식당'의 식당 사장들과 예산시장 상인들의 공통점은 개선과 발전을 위한 변화의 문턱을 넘지 못했다는 점입니다. 변화는 힘들고 어렵습니다. 그만큼 마음가짐도 준비가 되어야 온전히 받아들일 수..",
        serviceCategoryName: "교육",
        reactionCount: 237,
        commentCount: 51,
        entryPublished: "2023-12-23T08:00:12+09:00",
        firstReactionCreated: "2024-06-11T15:30:02.750963+09:00",
        isSupportBlog: true,
        supportCount: 9,
        supporters: [
          {
            blogImage:
              "https://t1.daumcdn.net/tistory_admin/blog/admin/profile.gif",
          },
          {
            blogImage:
              "https://tistory1.daumcdn.net/tistory/6043390/attach/8e497b9034194e79a6c66b39567a38fc",
          },
          {
            blogImage:
              "https://tistory1.daumcdn.net/tistory/5924475/attach/42950a6ce69f47fa9a702e71f0c076af",
          },
        ],
      },
      {
        authorId: 5528962,
        authorName: "방화문 마스터",
        blogId: 5751962,
        blogTitle: "방화문의 모든 것",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/5751962/attach/7ec153beaabb4535afb19c49fee4735e",
        blogUrl: "https://firedoor.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/yFNcZ/btsHTGZszhI/llTymFhwiAzHaGHpsnQ8UK/img.jpg",
        entryId: 287,
        entryTitle: "층간 소음방지 기준 및 층간 슬라브 두께 기준",
        entryUrl:
          "https://firedoor.tistory.com/entry/%EC%B8%B5%EA%B0%84-%EC%86%8C%EC%9D%8C%EB%B0%A9%EC%A7%80-%EA%B8%B0%EC%A4%80-%EB%B0%8F-%EC%B8%B5%EA%B0%84-%EC%8A%AC%EB%9D%BC%EB%B8%8C-%EB%91%90%EA%BB%98-%EA%B8%B0%EC%A4%80",
        entrySummary:
          '소음방지를 위한 층간 바닥충격음 차단 구조기준 제1조(목적) 이 기준은 「건축법」 제49조제3항 및 「건축물의 피난·방화구조 등의 기준에 관한 규칙」제19조제4항에 따라 가구·세대 등 간 소음방지를 위한 층간 바닥충격음 차단 구조기준을 제시하여 이웃 간의 층간소음 관련 분쟁으로 인한 인명 및 재산 피해를 사전에 예방하고 쾌적한 생활환경을 조성하는 것을 목적으로 한다.  제2조(정의) 이 기준에서 사용하는 용어의 뜻은 다음과 같다. 1. "바닥충격음 차단구조"란 「주택법」 제41조제1항에 따라 바닥충격음 차단구조의 성능등급을 인정하는 기관의 장이 차단구조의 성능[중량충격음(무겁고 부드러운 충격에 의한 바닥충격음을 말한다) 50데시벨 이하, 경량충격음(비교적 가볍고 딱딱한 충격에 의한 바닥충격음을 말한다) ..',
        serviceCategoryName: "경영·직장",
        reactionCount: 2,
        commentCount: 2,
        entryPublished: "2024-06-10T16:04:08+09:00",
        firstReactionCreated: "2024-06-11T15:30:02.755869+09:00",
        isSupportBlog: true,
        supportCount: 0,
        supporters: [],
      },
      {
        authorId: 5528962,
        authorName: "방화문 마스터",
        blogId: 5751962,
        blogTitle: "방화문의 모든 것",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/5751962/attach/7ec153beaabb4535afb19c49fee4735e",
        blogUrl: "https://firedoor.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/XwJTj/btsHSdqutjH/kp5fBODyOTXPeCxdcQGCL0/img.png",
        entryId: 283,
        entryTitle:
          "[방화문 인정제품] [세기에프에스디] [1] [FSD-C-TYPE-3H-AB-D2]",
        entryUrl:
          "https://firedoor.tistory.com/entry/%EB%B0%A9%ED%99%94%EB%AC%B8-%EC%9D%B8%EC%A0%95%EC%A0%9C%ED%92%88-%EC%84%B8%EA%B8%B0%EC%97%90%ED%94%84%EC%97%90%EC%8A%A4%EB%94%94-1-FSD-C-TYPE-3H-AB-D2",
        entrySummary: "",
        serviceCategoryName: "경영·직장",
        reactionCount: 2,
        commentCount: 2,
        entryPublished: "2024-06-10T13:23:58+09:00",
        firstReactionCreated: "2024-06-11T15:30:02.7587+09:00",
        isSupportBlog: true,
        supportCount: 0,
        supporters: [],
      },
    ],
    category: "current",
    hasNext: false,
  },
};

export const dummyItemCurrent = {
  error: false,
  data: {
    lastPublished: 1718077103000,
    list: [
      {
        uniqueId: "6775944_210",
        title: "실손의료보험(실비보험) 합리적으로 가입하는 방법",
        summary:
          "실손의료보험(실비보험) 합리적으로 가입하는 방법 실손의료보험은 실 생활에 매우 밀접하게 연관된 보험이고 많은 분들이 보유하고 있는 대중적인 상품입니다. 하지만 아무리 대중적인 보험이라 해도 평소에는 자주 접하지 않는 정보가 많이 포함되어 있는 보험이라는 특성상 많은 가입자가 본인에게 필요 없는 상품을 가입하는 경우가 많습니다. 따라서, 불필..",
        userId: 6495692,
        userName: "인포시커",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6775944/attach/a9b051849bae411c9fa0c0cb6bb00bfe",
        categoryName: "경제",
        thumbnail:
          "https://k.kakaocdn.net/dn/Z2Pyy/btsHUHqKmqg/qukaJ6JF7HV547JwzKMwAk/img.jpg",
        link: "https://lifeinfostorage.com/entry/실손의료보험실비보험-합리적으로-가입하는-방법",
        blogId: 6775944,
        blogTitle: "정보저장소",
        likeCount: 5,
        commentCount: 0,
        firstReactionCreated: 1718084910000,
        published: "2024.06.11 14:47",
        publishedAgo: "42분 전",
        supportCount: 0,
        encodedTitle:
          "%EC%8B%A4%EC%86%90%EC%9D%98%EB%A3%8C%EB%B3%B4%ED%97%98%28%EC%8B%A4%EB%B9%84%EB%B3%B4%ED%97%98%29%20%ED%95%A9%EB%A6%AC%EC%A0%81%EC%9C%BC%EB%A1%9C%20%EA%B0%80%EC%9E%85%ED%95%98%EB%8A%94%20%EB%B0%A9%EB%B2%95",
        encodedUserName: "%EC%9D%B8%ED%8F%AC%EC%8B%9C%EC%BB%A4",
      },
      {
        uniqueId: "6954074_691",
        title: "KB증권 주식계좌개설 공부하기 꿀팁",
        summary:
          "주식투자와 경제공부를 시작하려면 먼저 주식계좌를 개설해야 합니다. KB증권은 다양한 방법으로 주식계좌를 개설할 수 있어 편리합니다. 이번 글에서는 KB증권 주식계좌 개설 방법을 상세히 안내드리겠습니다.1. 비대면 계좌개설모바일 앱 이용가장 간편한 방법은 비대면으로 모바일 앱을 이용하는 것입니다. KB증권의 M-able 앱을 설치한 후, 신분증과 본인 명..",
        userId: 6600754,
        userName: "모르지",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6954074/attach/b47c78263a8d46c2a04def8a23de4ecc",
        categoryName: "사회",
        thumbnail:
          "https://k.kakaocdn.net/dn/lquca/btsHUUXwlus/uqo3mfhGHL7LrIAPIv3YkK/img.png",
        link: "https://circle-1.tistory.com/691",
        blogId: 6954074,
        blogTitle: "일상,여행,문화,연예,각종 이벤트,할인정보,꿀팁정보",
        likeCount: 17,
        commentCount: 20,
        firstReactionCreated: 1718081437000,
        published: "2024.06.11 13:46",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "KB%EC%A6%9D%EA%B6%8C%20%EC%A3%BC%EC%8B%9D%EA%B3%84%EC%A2%8C%EA%B0%9C%EC%84%A4%20%EA%B3%B5%EB%B6%80%ED%95%98%EA%B8%B0%20%EA%BF%80%ED%8C%81",
        encodedUserName: "%EB%AA%A8%EB%A5%B4%EC%A7%80",
      },
      {
        uniqueId: "188222_314",
        title: "버팀목대출보증 - 서민의 주거안정을 위한 복지사업",
        summary:
          "버팀목대출보증 - 서민의 주거안정을 위한 복지사업 제1금융권을 이용하기 어려운 금융소외계층에 대하여 주택금용신용보증기금을 통한 보증을 지원하는 사업이 있어 소개해 드리려고 합니다. 바로, '버팀목대출보증' 인데요.  임차보증금 수도권 7억원 이하, 지방 5억원 이하의 주택을 대상으로 대출금의 90%이내에서 보증을 지원하는 사업입니다. ..",
        userId: 190244,
        userName: "대지곰탱",
        userImage:
          "https://tistory1.daumcdn.net/tistory/188222/attach/c7a1762841244c408daa2302030e4f5f",
        categoryName: "경제",
        thumbnail:
          "https://k.kakaocdn.net/dn/AS5n0/btsHUdDxhzt/cjPYYtp8zaU1uxSYsGt751/img.jpg",
        link: "https://shakrock.tistory.com/314",
        blogId: 188222,
        blogTitle: "나만 몰랐던 이야기",
        likeCount: 24,
        commentCount: 30,
        firstReactionCreated: 1718081316000,
        published: "2024.06.11 13:48",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "%EB%B2%84%ED%8C%80%EB%AA%A9%EB%8C%80%EC%B6%9C%EB%B3%B4%EC%A6%9D%20-%20%EC%84%9C%EB%AF%BC%EC%9D%98%20%EC%A3%BC%EA%B1%B0%EC%95%88%EC%A0%95%EC%9D%84%20%EC%9C%84%ED%95%9C%20%EB%B3%B5%EC%A7%80%EC%82%AC%EC%97%85",
        encodedUserName: "%EB%8C%80%EC%A7%80%EA%B3%B0%ED%83%B1",
      },
      {
        uniqueId: "6668392_175",
        title: "아서 헤이즈의 예측과 1000배 폭등할 싱귤레리티 넷의 잠재력",
        summary:
          "암호화폐 시장은 급변하는 환경 속에서 많은 투자 기회를 제공합니다.그중에서도 코인 억만장자이자 투자 전문가인 아서 헤이즈의 예측은 많은 투자자들에게 큰 영향을 미치고 있습니다.본 블로그에서는 아서 헤이즈의 예측과 그의 견해가 어떻게 비트코인과 알트코인 시장에 영향을 미쳤는지 살펴보겠습니다. 또한, 1000배 폭등할 가능성이 있는 싱귤레리티 넷의 ..",
        userId: 6215052,
        userName: "머니마스터쥴리",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6668392/attach/97afa6cbd78c433aa03e384e3dca9385",
        categoryName: "경제",
        thumbnail:
          "https://k.kakaocdn.net/dn/bCa9yZ/btsHUhrXAHz/gAXdNl30MzPLZ0ijCImeK1/img.png",
        link: "https://julieheadline.com/entry/비트코인과-알트코인-투자-전략-아서-헤이즈의-예측과-1000배-폭등할-싱귤레리티-넷의-잠재력",
        blogId: 6668392,
        blogTitle: "머니마스터",
        likeCount: 30,
        commentCount: 1,
        firstReactionCreated: 1718081159000,
        published: "2024.06.10 22:41",
        publishedAgo: "오늘",
        supportCount: 0,
        encodedTitle:
          "%EC%95%84%EC%84%9C%20%ED%97%A4%EC%9D%B4%EC%A6%88%EC%9D%98%20%EC%98%88%EC%B8%A1%EA%B3%BC%201000%EB%B0%B0%20%ED%8F%AD%EB%93%B1%ED%95%A0%20%EC%8B%B1%EA%B7%A4%EB%A0%88%EB%A6%AC%ED%8B%B0%20%EB%84%B7%EC%9D%98%20%EC%9E%A0%EC%9E%AC%EB%A0%A5",
        encodedUserName:
          "%EB%A8%B8%EB%8B%88%EB%A7%88%EC%8A%A4%ED%84%B0%EC%A5%B4%EB%A6%AC",
      },
      {
        uniqueId: "5812720_198",
        title:
          "-\uDBC0\uDC01 소공인 경영안정 및 성장지원을 위한 -2024년 인천광역시 소공인 지원 특례보증 지원 계획 공고",
        summary:
          "-\uDBC0\uDC01 소공인 경영안정 및 성장지원을 위한 -2024년 인천광역시 소공인 지원 특례보증 지원 계획 공고소상공인기본법 제3조에 따라 소공인의 경영안정과 성장지원을 위한 「2024년 인천광역시 소공인 지원 특례보증」 지원 계획을 다음과 같이 공고 합니다.1. 융자규모: 100억원 2. 융자대상: 인천시 소재 상시 근로자 1..",
        userId: 5171508,
        userName: "피아노를 잘 가르치는 노타쌤",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5812720/attach/f576d2938163466caa55917c8ce2575e",
        categoryName: "경영·직장",
        thumbnail:
          "https://k.kakaocdn.net/dn/bnLq3g/btsHVHQD9TQ/rJxNtpYdYaLnALKw3LkflK/img.png",
        link: "https://no1worker.tistory.com/198",
        blogId: 5812720,
        blogTitle:
          "영종 하늘도시 중산초 하늘초 7분 거리 피아노 학원 교습소 음악의정원",
        likeCount: 5,
        commentCount: 2,
        firstReactionCreated: 1718080767000,
        published: "2024.06.11 13:39",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "-%F4%80%80%81%20%EC%86%8C%EA%B3%B5%EC%9D%B8%20%EA%B2%BD%EC%98%81%EC%95%88%EC%A0%95%20%EB%B0%8F%20%EC%84%B1%EC%9E%A5%EC%A7%80%EC%9B%90%EC%9D%84%20%EC%9C%84%ED%95%9C%20-2024%EB%85%84%20%EC%9D%B8%EC%B2%9C%EA%B4%91%EC%97%AD%EC%8B%9C%20%EC%86%8C%EA%B3%B5%EC%9D%B8%20%EC%A7%80%EC%9B%90%20%ED%8A%B9%EB%A1%80%EB%B3%B4%EC%A6%9D%20%EC%A7%80%EC%9B%90%20%EA%B3%84%ED%9A%8D%20%EA%B3%B5%EA%B3%A0",
        encodedUserName:
          "%ED%94%BC%EC%95%84%EB%85%B8%EB%A5%BC%20%EC%9E%98%20%EA%B0%80%EB%A5%B4%EC%B9%98%EB%8A%94%20%EB%85%B8%ED%83%80%EC%8C%A4",
      },
      {
        uniqueId: "7016827_96",
        title: "파이코인 가입 방법, Pi 네트워크 가입 하는법",
        summary:
          "파이코인 가입 방법, Pi 네트워크 가입 하는법파이코인 가입 서두르세요.! 파이코인 가입 방법, Pi 네트워크 가입 하는법에 대해 알아 보도록 하겠습니다. 요즘 스마트폰으로 가입만 하면 채굴이 가능한 파이코인 무료채굴이 대세입니다.​조금만 찾아보아도 파이코인이 왜 상장이 되고 비트코인을 능가할 만 한지 아실 겁니다.​메인넷 출시와 파이코인 상장 소..",
        userId: 6458773,
        userName: "코인마이닝",
        userImage:
          "https://tistory1.daumcdn.net/tistory/7016827/attach/ae80204020604500bdbc105913da1543",
        categoryName: "경제",
        thumbnail:
          "https://k.kakaocdn.net/dn/ent7HE/btsHVDU1JUi/rWiQlvs0EKmNdOKKrpG0w1/img.webp",
        link: "https://coin-minings.tistory.com/96",
        blogId: 7016827,
        blogTitle: "Pi Coin 핸드폰 무료채굴, 파이코인 가입방법",
        likeCount: 7,
        commentCount: 12,
        firstReactionCreated: 1718080158000,
        published: "2024.06.11 13:18",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%ED%8C%8C%EC%9D%B4%EC%BD%94%EC%9D%B8%20%EA%B0%80%EC%9E%85%20%EB%B0%A9%EB%B2%95%2C%20Pi%20%EB%84%A4%ED%8A%B8%EC%9B%8C%ED%81%AC%20%EA%B0%80%EC%9E%85%20%ED%95%98%EB%8A%94%EB%B2%95",
        encodedUserName: "%EC%BD%94%EC%9D%B8%EB%A7%88%EC%9D%B4%EB%8B%9D",
      },
      {
        uniqueId: "3207153_80",
        title: "스미토모 2.0 T 좌승식 전동 지게차 판매(카운터)",
        summary:
          "안녕하세요.(주)ANBG 입니다.오늘 소개해드릴 전동지게차는스미토모 51-FB20PE 모델입니다.  배터리 최상급 (작년 말에 교체)연식 - 2015.02마스트 - 2단 최고 4,530 mm사이트시프트 - X사용시간 - 6000h충전기 X, 세금계산서 O (부가세별도)운송비별도 (전국가능)가격은 9,800,000 입니다. 아주 약간의 조정 가능합니다.아래로 전화 & 문자 부탁드립니다~!..",
        userId: 3959816,
        userName: "지게차의 모든것",
        userImage:
          "https://tistory1.daumcdn.net/tistory/3207153/attach/d29c08eee9e745b3b6f21b7206a2d796",
        categoryName: "경영·직장",
        thumbnail:
          "https://k.kakaocdn.net/dn/vnEfJ/btsHTHLshaB/WCwv72kWjPtH6R9KXwmDvk/img.jpg",
        link: "https://yydtheworld.tistory.com/80",
        blogId: 3207153,
        blogTitle: "지게차의 모든 것!",
        likeCount: 5,
        commentCount: 8,
        firstReactionCreated: 1718079193000,
        published: "2024.06.11 13:12",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%8A%A4%EB%AF%B8%ED%86%A0%EB%AA%A8%202.0%20T%20%EC%A2%8C%EC%8A%B9%EC%8B%9D%20%EC%A0%84%EB%8F%99%20%EC%A7%80%EA%B2%8C%EC%B0%A8%20%ED%8C%90%EB%A7%A4%28%EC%B9%B4%EC%9A%B4%ED%84%B0%29",
        encodedUserName:
          "%EC%A7%80%EA%B2%8C%EC%B0%A8%EC%9D%98%20%EB%AA%A8%EB%93%A0%EA%B2%83",
      },
      {
        uniqueId: "4353246_424",
        title: "통합사회, 행복한 삶을 실현하기 위한 조건. 경제적 안정8",
        summary:
          "[10통사1-02-02] 행복한 삶을 실현하기 위한 조건으로 질 높은 정주 환경의 조성, 경제적 안정, 민주주의 발전 및 도덕적 실천의 필요성에 관해 탐구한다.후진 국민성 근성에는 천박한 물질주의가 뿌리내려 있다는 비난, 빌어먹을 한국인이은 돈 좋아하고, 물질을 추구한다는 것은 일면 맞는 말이기도 하다. 그리고 비교 평가하는 기질과 더불어 만족과 여유를 모른..",
        userId: 4664333,
        userName: "켓세라세라",
        userImage:
          "https://tistory1.daumcdn.net/tistory/4353246/attach/77fc8c68b18948a5984ea1f5ab05be07",
        categoryName: "교육",
        thumbnail:
          "https://k.kakaocdn.net/dn/2IbFW/btsHTTE7GjS/PyTIGHOxNcUzCkntNtybPK/tfile.bmp",
        link: "https://peursen.tistory.com/424",
        blogId: 4353246,
        blogTitle: "도량분계의 인사이트",
        likeCount: 10,
        commentCount: 4,
        firstReactionCreated: 1718079038000,
        published: "2024.06.11 13:08",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%ED%86%B5%ED%95%A9%EC%82%AC%ED%9A%8C%2C%20%ED%96%89%EB%B3%B5%ED%95%9C%20%EC%82%B6%EC%9D%84%20%EC%8B%A4%ED%98%84%ED%95%98%EA%B8%B0%20%EC%9C%84%ED%95%9C%20%EC%A1%B0%EA%B1%B4.%20%EA%B2%BD%EC%A0%9C%EC%A0%81%20%EC%95%88%EC%A0%958",
        encodedUserName: "%EC%BC%93%EC%84%B8%EB%9D%BC%EC%84%B8%EB%9D%BC",
      },
      {
        uniqueId: "5376737_88",
        title: "[우리말 연구의 첫걸음]단어의 유형_단일어,복합어,파생어,합성어",
        summary:
          "미국을 방문한다. 방미 訪美  그럼 폴란드를 방문한다는? 방파?!! 폴란드의 음역어는 파란(波蘭(지명))이다. 파란 波 물결 파 / 蘭 난초 란(난)그래서 폴란드를 방문한다는 방파라고 한다.  오랜만에 책장에서 대학원 때 원서처럼 들고 다녔던 「우리말 연구의 첫걸음」 책을 폈다. '한국어의 이해'는 필수강의였는데 주 교재가 이 책이었다. 421페이지 분량의 ..",
        userId: 5398401,
        userName: "Felicia",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5376737/attach/f62c52bc13d04a4db0cd488e36559f68",
        categoryName: "교육",
        thumbnail:
          "https://k.kakaocdn.net/dn/UeMk8/btsHUcqOmbm/KsYX93V21M4vqLsyQg3psK/img.png",
        link: "https://felicia8.tistory.com/entry/우리말-연구의-첫걸음단어의-유형단일어복합어파생어합성어",
        blogId: 5376737,
        blogTitle: "Korean Teacher_Felicia",
        likeCount: 5,
        commentCount: 6,
        firstReactionCreated: 1718078804000,
        published: "2024.06.11 13:06",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%5B%EC%9A%B0%EB%A6%AC%EB%A7%90%20%EC%97%B0%EA%B5%AC%EC%9D%98%20%EC%B2%AB%EA%B1%B8%EC%9D%8C%5D%EB%8B%A8%EC%96%B4%EC%9D%98%20%EC%9C%A0%ED%98%95_%EB%8B%A8%EC%9D%BC%EC%96%B4%2C%EB%B3%B5%ED%95%A9%EC%96%B4%2C%ED%8C%8C%EC%83%9D%EC%96%B4%2C%ED%95%A9%EC%84%B1%EC%96%B4",
        encodedUserName: "Felicia",
      },
      {
        uniqueId: "5052129_4192",
        title:
          "[시진핑 유럽방문 목적은 EU-NATO 분열 모색] 서방과 아시아 자유주의 세력이 해야 할 맞대응책은?",
        summary:
          "[시진핑 유럽방문 목적은 EU-NATO 분열 모색] 서방과 아시아 자유주의 세력이 해야 할 맞대응책은? 2024년 5월 6일 영국 파이낸셜타임스는 시진핑은 유럽연합(EU)과 북대서양조약기구(NATO)의 분열 모색이라는 제목의 기드온 라크만 신문 외교 해설가의 논설을 내세워 시진핑 유럽 방문의 목적과 한계를 논하고 있다. 5년여 만에 시진핑의..",
        userId: 5145536,
        userName: "소식쟁이2",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5052129/attach/2bab65020f4e484e9d5b06609f0ff91b",
        categoryName: "경영·직장",
        thumbnail: null,
        link: "https://ququ99.tistory.com/4192",
        blogId: 5052129,
        blogTitle: "Why!  궁금하다! 궁금해!!",
        likeCount: 22,
        commentCount: 28,
        firstReactionCreated: 1718078622000,
        published: "2024.06.11 13:01",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%5B%EC%8B%9C%EC%A7%84%ED%95%91%20%EC%9C%A0%EB%9F%BD%EB%B0%A9%EB%AC%B8%20%EB%AA%A9%EC%A0%81%EC%9D%80%20EU-NATO%20%EB%B6%84%EC%97%B4%20%EB%AA%A8%EC%83%89%5D%20%EC%84%9C%EB%B0%A9%EA%B3%BC%20%EC%95%84%EC%8B%9C%EC%95%84%20%EC%9E%90%EC%9C%A0%EC%A3%BC%EC%9D%98%20%EC%84%B8%EB%A0%A5%EC%9D%B4%20%ED%95%B4%EC%95%BC%20%ED%95%A0%20%EB%A7%9E%EB%8C%80%EC%9D%91%EC%B1%85%EC%9D%80%3F",
        encodedUserName: "%EC%86%8C%EC%8B%9D%EC%9F%81%EC%9D%B42",
      },
      {
        uniqueId: "6454872_527",
        title: "버팀목 전세자금대출, 디딤돌 대출의 차이(조건, 한도, 금리)",
        summary:
          "버팀목 전세자금 대출과 디딤돌 대출의 차이를 알아보자!  \uD83C\uDFE1버팀목 전세자금대출 전세자금이 부족한 사람들을 위해 마련된 대출 상품이다 낮은 금리로 대출이자에 대한 부담은 낮춰줄 수 있지만, 해당되는 소득조건과 대상 주택을 꼼꼼히 확인하고 신청해야한다.똥, 청년들을 위한 청년전용 버팀목 전세자금대출이 따로 있으니 19 ~34세 무주택 청년들은 ..",
        userId: 6269359,
        userName: "pang.pangG",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6454872/attach/269f713d05e548cf9f30dba2e5e70751",
        categoryName: "경제",
        thumbnail:
          "https://k.kakaocdn.net/dn/3OOBb/btsHUymSvvP/W91VBwIPPuHGmZSxcNPLl1/img.png",
        link: "https://kikimong.tistory.com/527",
        blogId: 6454872,
        blogTitle: "뿌의 이슈 정리",
        likeCount: 8,
        commentCount: 7,
        firstReactionCreated: 1718078327000,
        published: "2024.06.11 12:53",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%EB%B2%84%ED%8C%80%EB%AA%A9%20%EC%A0%84%EC%84%B8%EC%9E%90%EA%B8%88%EB%8C%80%EC%B6%9C%2C%20%EB%94%94%EB%94%A4%EB%8F%8C%20%EB%8C%80%EC%B6%9C%EC%9D%98%20%EC%B0%A8%EC%9D%B4%28%EC%A1%B0%EA%B1%B4%2C%20%ED%95%9C%EB%8F%84%2C%20%EA%B8%88%EB%A6%AC%29",
        encodedUserName: "pang.pangG",
      },
      {
        uniqueId: "5000833_20",
        title:
          "[재무회계 자격증] 재경관리사를 알아보자! (삼일회계법인, 회계 이론 자격증)",
        summary:
          "# 본론에 들어가기 전 안녕하세요. 재무회계팀 임대리 입니다. 이번시간에는 재무회계팀 취업을 준비하거나, 공부 겸 자격취득을 생각중인 실무자들에게 '재경관리사' 라는 자격증에 대해 소개해드리고자 합니다. 재경관리사 자격증은 국내 최고의 회계법인 '삼일회계법인'에서 주관하는 이론 자격증으로, 실무가 포함되지 않아서 단순히 '문제은행' 이라는 평가도 ..",
        userId: 5108063,
        userName: "재무팀 임대리",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5000833/attach/eccdb1b599b4416fa5aa0f47a75dc0d9",
        categoryName: "경영·직장",
        thumbnail:
          "https://k.kakaocdn.net/dn/tSodB/btrkor5wzSd/q5UrOuakld87zhsgXWINok/img.png",
        link: "https://narakstory.tistory.com/20",
        blogId: 5000833,
        blogTitle: "재무회계팀 임대리 이야기",
        likeCount: 10,
        commentCount: 4,
        firstReactionCreated: 1718077103000,
        published: "2021.11.10 01:20",
        publishedAgo: "2021.11.10",
        supportCount: 0,
        encodedTitle:
          "%5B%EC%9E%AC%EB%AC%B4%ED%9A%8C%EA%B3%84%20%EC%9E%90%EA%B2%A9%EC%A6%9D%5D%20%EC%9E%AC%EA%B2%BD%EA%B4%80%EB%A6%AC%EC%82%AC%EB%A5%BC%20%EC%95%8C%EC%95%84%EB%B3%B4%EC%9E%90%21%20%28%EC%82%BC%EC%9D%BC%ED%9A%8C%EA%B3%84%EB%B2%95%EC%9D%B8%2C%20%ED%9A%8C%EA%B3%84%20%EC%9D%B4%EB%A1%A0%20%EC%9E%90%EA%B2%A9%EC%A6%9D%29",
        encodedUserName:
          "%EC%9E%AC%EB%AC%B4%ED%8C%80%20%EC%9E%84%EB%8C%80%EB%A6%AC",
      },
    ],
    category: "current",
    hasNext: true,
  },
};

export const dummyItemCurrent2 ={
  "error": false,
  "data": {
    "lastPublished": 1718877679000,
    "list": [
      {
        "uniqueId": "6954074_810",
        "title": "이마트II KB국민카드 옐로우 캐시백 이벤트 꿀팁",
        "summary": "이마트II KB국민카드 옐로우 캐시백 이벤트로 최대 혜택 누리기 이마트II KB국민카드 옐로우는 다양한 할인 혜택과 캐시백 이벤트로 많은 소비자들에게 인기를 끌고 있습니다. 이번 글에서는 이 카드의 주요 혜택과 현재 진행 중인 캐시백 이벤트에 대해 자세히 알아보겠습니다.이마트II KB국민카드 옐로우 주요 혜택 및 캐시백 이벤트 주요 혜택이마트II KB국민카드..",
        "userId": 6600754,
        "userName": "모르지",
        "userImage": "https://tistory1.daumcdn.net/tistory/6954074/attach/b47c78263a8d46c2a04def8a23de4ecc",
        "categoryName": "경제",
        "thumbnail": "https://k.kakaocdn.net/dn/beJIdn/btsH5zz5phH/m3ZKZUH7h9huWTbKHmLjvk/img.png",
        "link": "https://circle-1.tistory.com/810",
        "blogId": 6954074,
        "blogTitle": "일상,여행,각종 이벤트,할인정보,꿀팁정보",
        "likeCount": 5,
        "commentCount": 6,
        "firstReactionCreated": 1718890317000,
        "published": "2024.06.20 22:30",
        "publishedAgo": "7분 전",
        "supportCount": 0,
        "encodedTitle": "%EC%9D%B4%EB%A7%88%ED%8A%B8II%20KB%EA%B5%AD%EB%AF%BC%EC%B9%B4%EB%93%9C%20%EC%98%90%EB%A1%9C%EC%9A%B0%20%EC%BA%90%EC%8B%9C%EB%B0%B1%20%EC%9D%B4%EB%B2%A4%ED%8A%B8%20%EA%BF%80%ED%8C%81",
        "encodedUserName": "%EB%AA%A8%EB%A5%B4%EC%A7%80"
      },
      {
        "uniqueId": "5202180_1110",
        "title": "[교육부 / 청소년] 학생 상담 채널 라임(LIME)",
        "summary": "[청소년] 학생 상담 채널 라임(LIME)   마음 건강을 관리하고 위기 학생을 지원하는 학생 상담 채널 '라임(LIME)'이 운영이 돼요. 모바일 기반의 24시간 상담 채널로, 9세부터 24세까지 청소년을 대상으로 전문적인 심리 상담을 지원해요.  교육부는 20일 삼성금융네트웍스, 한국생명의 전화와 함께 삼성 금융 캠페인(서울)에서 학생 상담 채널 '라임(LIME)' ..",
        "userId": 5267668,
        "userName": "청바지와 청치마",
        "userImage": "https://tistory1.daumcdn.net/tistory/5202180/attach/402f0f9e40b94af788713adfae827d45",
        "categoryName": "교육",
        "thumbnail": "https://k.kakaocdn.net/dn/L2dC5/btsH5NdWNWf/jqBjLBzQhehmQCrdwFW901/img.jpg",
        "link": "https://sorasr.tistory.com/1110",
        "blogId": 5202180,
        "blogTitle": "경험•기억•생각",
        "likeCount": 12,
        "commentCount": 19,
        "firstReactionCreated": 1718887859000,
        "published": "2024.06.20 21:42",
        "publishedAgo": "56분 전",
        "supportCount": 0,
        "encodedTitle": "%5B%EA%B5%90%EC%9C%A1%EB%B6%80%20%2F%20%EC%B2%AD%EC%86%8C%EB%85%84%5D%20%ED%95%99%EC%83%9D%20%EC%83%81%EB%8B%B4%20%EC%B1%84%EB%84%90%20%EB%9D%BC%EC%9E%84%28LIME%29",
        "encodedUserName": "%EC%B2%AD%EB%B0%94%EC%A7%80%EC%99%80%20%EC%B2%AD%EC%B9%98%EB%A7%88"
      },
      {
        "uniqueId": "6954074_809",
        "title": "롯데렌터카 배달받기 서비스 만원 이벤트 실시 2024년 6월 17일부터 7월 16일까지",
        "summary": "롯데렌터카의 혁신적인 서비스: 배달받기 서비스롯데렌터카는 여름 성수기를 맞아 고객 편의를 극대화하기 위해 ‘배달받기 서비스’ 할인 이벤트를 진행합니다. 이번 이벤트는 2024년 6월 17일부터 7월 16일까지 한 달간 진행되며, 모든 단기렌터카 차종을 대상으로 합니다. 고객은 롯데렌터카 앱이나 웹사이트에서 사전 예약을 통해 배달받기 서비스를 주중 편도..",
        "userId": 6600754,
        "userName": "모르지",
        "userImage": "https://tistory1.daumcdn.net/tistory/6954074/attach/b47c78263a8d46c2a04def8a23de4ecc",
        "categoryName": "경제",
        "thumbnail": "https://k.kakaocdn.net/dn/stZl0/btsH6ePqdeY/QPjX7eKsyoZMBs2ZUqgW71/img.png",
        "link": "https://circle-1.tistory.com/809",
        "blogId": 6954074,
        "blogTitle": "일상,여행,각종 이벤트,할인정보,꿀팁정보",
        "likeCount": 19,
        "commentCount": 26,
        "firstReactionCreated": 1718886562000,
        "published": "2024.06.20 21:28",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "%EB%A1%AF%EB%8D%B0%EB%A0%8C%ED%84%B0%EC%B9%B4%20%EB%B0%B0%EB%8B%AC%EB%B0%9B%EA%B8%B0%20%EC%84%9C%EB%B9%84%EC%8A%A4%20%EB%A7%8C%EC%9B%90%20%EC%9D%B4%EB%B2%A4%ED%8A%B8%20%EC%8B%A4%EC%8B%9C%202024%EB%85%84%206%EC%9B%94%2017%EC%9D%BC%EB%B6%80%ED%84%B0%207%EC%9B%94%2016%EC%9D%BC%EA%B9%8C%EC%A7%80",
        "encodedUserName": "%EB%AA%A8%EB%A5%B4%EC%A7%80"
      },
      {
        "uniqueId": "5953674_256",
        "title": "저출생 대책, 육아휴직 월급여와 아이돌봄서비스, 출산가구 주택 공급 등 내용과 문제점",
        "summary": "출산율이 계속 떨어지자 정부가 인구 국가비상사태를 선언하며 저출생 대책을 발표했다. 일과 가정의 양립, 양육, 주거 등을 저출생 3대 핵심 대책으로 내세웠지만 저출생의 원인에 대한 근본적인 고민과 효과가 있을 법한 대책은 보이지 않는 듯하다.정부가 발표한 저출생 대책의 내용과 문제점을 살펴본다. 저출생 대책, 육아휴직 월급여와 아이돌봄서비스, 출산..",
        "userId": 5865519,
        "userName": "호외요!",
        "userImage": "https://tistory1.daumcdn.net/tistory/5953674/attach/ea9f74fd0e334af68c8139eddbc2c2ee",
        "categoryName": "사회",
        "thumbnail": "https://k.kakaocdn.net/dn/dwGFcU/btsH7x8kIlY/xauaqjyip70O7ACsqT6Ze1/img.jpg",
        "link": "https://artopic.tistory.com/256",
        "blogId": 5953674,
        "blogTitle": "아트토픽",
        "likeCount": 9,
        "commentCount": 11,
        "firstReactionCreated": 1718884294000,
        "published": "2024.06.20 20:44",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%A0%80%EC%B6%9C%EC%83%9D%20%EB%8C%80%EC%B1%85%2C%20%EC%9C%A1%EC%95%84%ED%9C%B4%EC%A7%81%20%EC%9B%94%EA%B8%89%EC%97%AC%EC%99%80%20%EC%95%84%EC%9D%B4%EB%8F%8C%EB%B4%84%EC%84%9C%EB%B9%84%EC%8A%A4%2C%20%EC%B6%9C%EC%82%B0%EA%B0%80%EA%B5%AC%20%EC%A3%BC%ED%83%9D%20%EA%B3%B5%EA%B8%89%20%EB%93%B1%20%EB%82%B4%EC%9A%A9%EA%B3%BC%20%EB%AC%B8%EC%A0%9C%EC%A0%90",
        "encodedUserName": "%ED%98%B8%EC%99%B8%EC%9A%94%21"
      },
      {
        "uniqueId": "5088031_4542",
        "title": "신발 매출 100이라고 하면 나이키 47%, 아디다스 35%,",
        "summary": "[대신증권 유통/의류 유정현] 요즘 운동화 시장 회복에 수혜 기업인 백산이 호실적과 주주 친화정책으로 주가가 좋습니다. 컨콜 내용 보내드리니 참고해주세요 ★ 백산 컨퍼런스 콜 정리 (24.06.20) ▶️ Q&A 1. 현재 주요 고객사 내 경쟁 구도가 어떤 상황인지 - 신발 매출 100이라고 하면 나이키 47%, 아디다스 35%, 나머지는 리복, 아식스, 퓨마, 뉴발란스, 라코..",
        "userId": 5174635,
        "userName": "INTP미국투자자",
        "userImage": "https://tistory1.daumcdn.net/tistory/5088031/attach/6696be2777db4d2ea1f8d302e3f926d4",
        "categoryName": "경제",
        "thumbnail": null,
        "link": "https://wkdnsskfk.tistory.com/4542",
        "blogId": 5088031,
        "blogTitle": "미국주식으로 은퇴하기",
        "likeCount": 17,
        "commentCount": 13,
        "firstReactionCreated": 1718883091000,
        "published": "2024.06.20 20:30",
        "publishedAgo": "2시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%8B%A0%EB%B0%9C%20%EB%A7%A4%EC%B6%9C%20100%EC%9D%B4%EB%9D%BC%EA%B3%A0%20%ED%95%98%EB%A9%B4%20%EB%82%98%EC%9D%B4%ED%82%A4%2047%25%2C%20%EC%95%84%EB%94%94%EB%8B%A4%EC%8A%A4%2035%25%2C",
        "encodedUserName": "INTP%EB%AF%B8%EA%B5%AD%ED%88%AC%EC%9E%90%EC%9E%90"
      },
      {
        "uniqueId": "5692194_7733720",
        "title": "\"감당할 수 있겠습니까?\"",
        "summary": "특검 청문회 앞둔 '경고' https://youtu.be/NzzqKw5mu3Q?si=JvgBcwkvfjRTdUDj",
        "userId": 5654126,
        "userName": "또바기1957",
        "userImage": "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
        "categoryName": "정치",
        "thumbnail": null,
        "link": "https://mihwang.tistory.com/entry/감당할-수-있겠습니까",
        "blogId": 5692194,
        "blogTitle": "참",
        "likeCount": 7,
        "commentCount": 5,
        "firstReactionCreated": 1718882479000,
        "published": "2024.06.20 19:40",
        "publishedAgo": "2시간 전",
        "supportCount": 0,
        "encodedTitle": "%22%EA%B0%90%EB%8B%B9%ED%95%A0%20%EC%88%98%20%EC%9E%88%EA%B2%A0%EC%8A%B5%EB%8B%88%EA%B9%8C%3F%22",
        "encodedUserName": "%EB%98%90%EB%B0%94%EA%B8%B01957"
      },
      {
        "uniqueId": "5572828_2005",
        "title": "청랑의 어휘 끝장내기 : sect",
        "summary": "오늘은 sect 이라는 어원에 대해 알아보겠습니다. \"sect : 자르다\"라는 의미로 동사를 나타냅니다.여러분이 알고 있는 단어 중 동사를 나타내는 sect 가 들어가는 단어는 무엇이 있나요?",
        "userId": 5557808,
        "userName": "JadeWolveS",
        "userImage": "https://tistory1.daumcdn.net/tistory/5572828/attach/ce371994a5c5423c8cddef0d0511ed05",
        "categoryName": "교육",
        "thumbnail": "https://k.kakaocdn.net/dn/crMxXk/btsH7gFw9GO/QKCmQRRkOZzoBE8Mq4BhRK/img.png",
        "link": "https://jadewolves.tistory.com/entry/5",
        "blogId": 5572828,
        "blogTitle": "청랑",
        "likeCount": 11,
        "commentCount": 4,
        "firstReactionCreated": 1718881467000,
        "published": "2024.06.20 20:00",
        "publishedAgo": "2시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%B2%AD%EB%9E%91%EC%9D%98%20%EC%96%B4%ED%9C%98%20%EB%81%9D%EC%9E%A5%EB%82%B4%EA%B8%B0%20%3A%20sect",
        "encodedUserName": "JadeWolveS"
      },
      {
        "uniqueId": "2866622_18444",
        "title": "남월국 왕묘가 일깨운 것들",
        "summary": "2007년 광동성 광주 남월국 문물 답사는 나한테는 여러 가지를 일깨운 기회였다. 남월국은 그 태동 시기, 태동 주체, 멸망 시점이 위만조선과 일란성 쌍둥이다. 남월국 창건주 조타는 산동성 출신으로 남월국에서 독립해 남월국을 세웠다. 현지 민족과의 복합세력이 구축한 왕조로 100년간 지속하다가 기원전 111년인가 한 무제에게 멸망당하고 그 땅에는 7군이 설..",
        "userId": 3740250,
        "userName": "taeshik.kim",
        "userImage": "https://t1.daumcdn.net/cfile/tistory/99B2503C5A628E841F",
        "categoryName": "교육",
        "thumbnail": "https://k.kakaocdn.net/dn/d20NLx/btsH6fAU3tt/KNIPu6sA5PKCGu2fxWkT31/img.jpg",
        "link": "https://historylibrary.net/entry/남월국-왕묘",
        "blogId": 2866622,
        "blogTitle": "The HERITAGE TRIBUNE",
        "likeCount": 5,
        "commentCount": 2,
        "firstReactionCreated": 1718880455000,
        "published": "2024.06.20 19:05",
        "publishedAgo": "3시간 전",
        "supportCount": 0,
        "encodedTitle": "%EB%82%A8%EC%9B%94%EA%B5%AD%20%EC%99%95%EB%AC%98%EA%B0%80%20%EC%9D%BC%EA%B9%A8%EC%9A%B4%20%EA%B2%83%EB%93%A4",
        "encodedUserName": "taeshik.kim"
      },
      {
        "uniqueId": "5692194_7733719",
        "title": "[오대영 라이브] '원희룡 출마'로 당에 메시지?",
        "summary": "끊이지 않는 대통령실 개입설 https://youtu.be/F2liyiT4WZ4?si=kFoFK5DwcoWvkZhm",
        "userId": 5654126,
        "userName": "또바기1957",
        "userImage": "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
        "categoryName": "정치",
        "thumbnail": null,
        "link": "https://mihwang.tistory.com/entry/오대영-라이브-원희룡-출마로-당에-메시지",
        "blogId": 5692194,
        "blogTitle": "참",
        "likeCount": 9,
        "commentCount": 6,
        "firstReactionCreated": 1718879437000,
        "published": "2024.06.20 18:34",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "%5B%EC%98%A4%EB%8C%80%EC%98%81%20%EB%9D%BC%EC%9D%B4%EB%B8%8C%5D%20%27%EC%9B%90%ED%9D%AC%EB%A3%A1%20%EC%B6%9C%EB%A7%88%27%EB%A1%9C%20%EB%8B%B9%EC%97%90%20%EB%A9%94%EC%8B%9C%EC%A7%80%3F",
        "encodedUserName": "%EB%98%90%EB%B0%94%EA%B8%B01957"
      },
      {
        "uniqueId": "5676620_715",
        "title": "24.06.20(목) 금일 상승률Top30 시간외 단일가 특징주 및 내일이슈",
        "summary": "안녕하세요!여러분들의 주린이 탈출을 돕기위한 탈출작전의 리더 차트충입니다. 요즘같이 불확실하고 어려운 시장에서도 살아남기위해, 차트충이 열심히 핫한 섹터를 발굴해보도록 하겠습니다.자, 주린이 탈출작전 시작합니다.여기 섹터에는 오늘 하루 이슈되는 시황 혹은 (경제)기사들 정리하여 올려드리도록 하겠습니다:)  \u003E 카카오톡 오픈채팅..",
        "userId": 5641319,
        "userName": "차트충",
        "userImage": "https://tistory1.daumcdn.net/tistory/5676620/attach/8b7b86d7e6b24a12aa3371bb85d76792",
        "categoryName": "경제",
        "thumbnail": "https://k.kakaocdn.net/dn/m7BbN/btsH6RNaelm/d9EKlCEUwHdPmb0AgkY24K/img.png",
        "link": "https://chart-worm.tistory.com/715",
        "blogId": 5676620,
        "blogTitle": "차트충의 주린이 탈출작전",
        "likeCount": 8,
        "commentCount": 7,
        "firstReactionCreated": 1718879145000,
        "published": "2024.06.20 19:22",
        "publishedAgo": "3시간 전",
        "supportCount": 0,
        "encodedTitle": "24.06.20%28%EB%AA%A9%29%20%EA%B8%88%EC%9D%BC%20%EC%83%81%EC%8A%B9%EB%A5%A0Top30%20%EC%8B%9C%EA%B0%84%EC%99%B8%20%EB%8B%A8%EC%9D%BC%EA%B0%80%20%ED%8A%B9%EC%A7%95%EC%A3%BC%20%EB%B0%8F%20%EB%82%B4%EC%9D%BC%EC%9D%B4%EC%8A%88",
        "encodedUserName": "%EC%B0%A8%ED%8A%B8%EC%B6%A9"
      },
      {
        "uniqueId": "5786979_515",
        "title": "알리바바의 홈플러스 인수설, 추진 목적은?",
        "summary": "알리바바 홈플러스 인수설MBK파트너스가 대주주인 홈플러스는 최근 SSM인 홈플러스 익스프레스의 매각을 공식화하였고, 언론 상에서는 알리익스프레스(알리바바)의 인수 가능성이 지속적으로 대두되어 왔다. 최근에는 알리바바와 홈플러스(MBK)의 경영진이 국내와 중국 등에서 접촉했다는 설이 언론 상에서 확산되면서, 매각 대상이 매각을 공식화한 홈플러..",
        "userId": 5729804,
        "userName": "00년 새내기",
        "userImage": "https://tistory1.daumcdn.net/tistory/5786979/attach/0e9db686e3d9458f9de98f8db33c875d",
        "categoryName": "경제",
        "thumbnail": "https://k.kakaocdn.net/dn/cq2rWT/btsH6NRu8ZB/9XOYFW0lB6QQaoy4B3Ykk1/img.jpg",
        "link": "https://9078kusoos.tistory.com/515",
        "blogId": 5786979,
        "blogTitle": "퍼플마블",
        "likeCount": 6,
        "commentCount": 1,
        "firstReactionCreated": 1718878591000,
        "published": "2024.06.20 19:15",
        "publishedAgo": "3시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%95%8C%EB%A6%AC%EB%B0%94%EB%B0%94%EC%9D%98%20%ED%99%88%ED%94%8C%EB%9F%AC%EC%8A%A4%20%EC%9D%B8%EC%88%98%EC%84%A4%2C%20%EC%B6%94%EC%A7%84%20%EB%AA%A9%EC%A0%81%EC%9D%80%3F",
        "encodedUserName": "00%EB%85%84%20%EC%83%88%EB%82%B4%EA%B8%B0"
      },
      {
        "uniqueId": "5692194_7733718",
        "title": "\"지연된 정의는 정의가 아니다\"",
        "summary": "'논문 검증파' 숙대 총장 확정 https://youtu.be/8tPtt795muI?si=M7vYZ61esMh7jLEb",
        "userId": 5654126,
        "userName": "또바기1957",
        "userImage": "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
        "categoryName": "교육",
        "thumbnail": null,
        "link": "https://mihwang.tistory.com/entry/지연된-정의는-정의가-아니다",
        "blogId": 5692194,
        "blogTitle": "참",
        "likeCount": 10,
        "commentCount": 8,
        "firstReactionCreated": 1718877679000,
        "published": "2024.06.20 18:28",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "%22%EC%A7%80%EC%97%B0%EB%90%9C%20%EC%A0%95%EC%9D%98%EB%8A%94%20%EC%A0%95%EC%9D%98%EA%B0%80%20%EC%95%84%EB%8B%88%EB%8B%A4%22",
        "encodedUserName": "%EB%98%90%EB%B0%94%EA%B8%B01957"
      }
    ],
    "category": "current",
    "hasNext": true
  }
}